import { singleton } from 'tsyringe';
import { OWInternalProfile } from '../../odk-internal-ts/ow-internal-profile';
import { OWInternalUtils } from '../../odk-internal-ts/ow-internal-utils';
import { OWUtils } from '../../odk-ts';

type ClientInfoResult = overwolf.utils.ClientInfoResult;

// -----------------------------------------------------------------------------
// Testable wrapper for utils
@singleton()
export class OWUtilsWrapper {
  private patchedClientLaunchedTime: Date;

  // ---------------------------------------------------------------------------
  // NOTE(twolf): We use this as a patch for backwards compatibility for those
  // clients that do not have support for the |getClientInfo| API
  public setClientStartupTime() {
    this.patchedClientLaunchedTime = new Date();
  }

  // ---------------------------------------------------------------------------
  public openStoreOneAppPage(uid: string) {
    OWUtils.openStoreOneAppPage(uid);
  }

  // ---------------------------------------------------------------------------
  public getClientInfo(): Promise<ClientInfoResult> {
    // TEST(twolf): e2e where isGetClientInfoSupported doesn't exist
    if (!OWUtils.isGetClientInfoSupported()) {
      return this.getClientInfoFromPatchValues();
    }

    return OWUtils.getClientInfo();
  }

  // ---------------------------------------------------------------------------
  public async getPersistentPhasedPercent() {
    return OWInternalUtils.getPersistentPhasedPercent();
  }

  // ---------------------------------------------------------------------------
  private async getClientInfoFromPatchValues(): Promise<ClientInfoResult> {
    const installTime = await this.getConsentTimestamp();
    const uptimeSeconds = this.calcUptimeFromPatchedLaunchedTimeInSeconds();

    return {
      success: true,
      installTime,
      uptimeSeconds,
    };
  }

  // ---------------------------------------------------------------------------
  private async getConsentTimestamp(): Promise<number> {
    let consentTimestamp: number;
    const internalProfile = await OWInternalProfile.getCurrentUser().catch(
      (result) => {
        consentTimestamp = result.consentTimestamp;
      },
    );

    if (internalProfile) {
      consentTimestamp = internalProfile.consentTimestamp;
    }

    return consentTimestamp;
  }

  // ---------------------------------------------------------------------------
  private calcUptimeFromPatchedLaunchedTimeInSeconds() {
    return (Date.now() - this.patchedClientLaunchedTime.getTime()) / 1000;
  }

  // ---------------------------------------------------------------------------
  public async getSystemInformation() {
    return OWUtils.getSystemInformation();
  }

  // ---------------------------------------------------------------------------
  public openUrlInDefaultBrowser(url: string): void {
    OWUtils.openUrlInDefaultBrowser(url);
  }
}
